export const ConfigConnectionFragment = gql`
  fragment ConfigConnectionFragment on ConfigConnection {
    organization {
      id
      displayName
    }
    recordTemplate {
      id
      name
    }
    recordType {
      id
      displayName
    }
  }
`
